import { Box, Grid, Typography } from "@mui/material";
import { useAtom, useAtomValue } from "jotai";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { getPublicUrl } from "@/lib/common-utils";
import { headerTitle, isDarkMode } from "@/store/store";

const HomePage = () => {
  const { t } = useTranslation();

  const [, setHeaderTitle] = useAtom(headerTitle);
  const isDark = useAtomValue(isDarkMode);

  const logoName = useMemo(() => (isDark ? "main_logo_light.png" : "main_logo.png"), [isDark]);

  useEffect(() => {
    setHeaderTitle(t("home"));
  }, [setHeaderTitle, t]);

  return (
    <Grid
      container
      sx={{
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        textAlign: "center",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            src={`${getPublicUrl()}/${logoName}`}
            alt="Main logo"
            sx={{
              width: "100%",
              maxWidth: 350,
              height: "auto",
            }}
          />
        </Box>
      </Grid>

      <Grid>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 600,
          }}
        >
          {t("asiaProjectAdminPanel")}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default HomePage;
